import type SubstrateSearchScenario from '../data/schema/SubstrateSearchScenario';
import getSubstrateSearchEndpoint from '../helpers/getSubstrateSearchEndpoint';
import { makeGetRequest } from 'owa-ows-gateway';
import buildQueryParams from '../helpers/buildQueryParams';
import { trace } from 'owa-trace';
import getUrlWithAddedQueryParameters from 'owa-url/lib/getUrlWithAddedQueryParameters';
import type { MailboxInfo } from 'owa-client-types';

/**
 * This route is responsible for providing completions/suggestions for the given prefix.
 * The type of suggestions returned would be based on the configuration done at 3S API.
 * TODO: Return type of Response is not guaranteed as makeGetRequest can return other types.
 */
export default function substrateSearchSuggestionsService(
    queryString: string,
    searchSessionGuid: string,
    cvid: string,
    entityTypes: string,
    substrateSearchScenario: SubstrateSearchScenario,
    /* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
     *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
    customHeaders?: any,
    logicalId?: string,
    serverFlights?: string,
    mailboxInfo?: MailboxInfo
): Promise<Response | null> {
    const defaultParams: {
        cvid: string;
        query: string;
        textdecorations: string;
        scenario: SubstrateSearchScenario;
        entityTypes: string;
        logicalId?: string;
        setflight?: string;
    } = {
        cvid,
        query: queryString,
        textdecorations: '1',
        scenario: substrateSearchScenario,
        entityTypes,
    };

    if (logicalId) {
        defaultParams['logicalId'] = logicalId;
    }

    if (serverFlights && queryString?.length > 0) {
        defaultParams['setflight'] = serverFlights;
    }

    if (searchSessionGuid) {
        /* eslint-disable-next-line owa-custom-rules/require-mailboxInfoInOwsRequest  -- (https://aka.ms/OWALintWiki)
         * MailboxInfo must be providded to OWS calls, see https://aka.ms/multiaccountlinter
         *	> All OWS calls must pass in a MailboxInfo or OwsRequestOptions obtained via getOwsMailboxRequestOptions. */
        return makeGetRequest(
            getUrlWithAddedQueryParameters(
                getSubstrateSearchEndpoint('suggestions'),
                buildQueryParams(defaultParams)
            ),
            undefined /* correlationId */,
            true /* returnFullResponse */,
            customHeaders,
            undefined /* throwServiceError */,
            /* 3S does not need auth cookies so omitting them will decrease request header size */
            false /* includeCredentials */,
            'substrateSearchSuggestions' /* actionName */,
            mailboxInfo
        )
            .then(resp => {
                return resp;
            })
            .catch(err => {
                trace.warn(err);
                return null;
            });
    } else {
        return Promise.resolve(null);
    }
}
